import angular from 'angular';
import threatScore from './threatScore';
import directive from './threats-scores.directive';


export default angular.module('app.components.advisory.bcp.settings.threatsScores', [
  threatScore,
])
  .directive('bcpThreatsScores', directive)
  .name;

console.log('app.components.advisory.bcp.settings.threatsScores created');
